import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { techRadarApi } from '@backstage-community/plugin-tech-radar/alpha';
import {
  configApiRef,
  createFrontendModule,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';

import { TechRadarClient } from './TechRadarClient';

const homegateTechRadarApi = techRadarApi.override({
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ configApi, fetchApi }) =>
        new TechRadarClient(configApi, fetchApi),
    }),
});

export const techRadarHomegateModule = createFrontendModule({
  pluginId: 'tech-radar',
  extensions: [homegateTechRadarApi],
});
